import React, { useMemo } from 'react';
import active_email from 'assets/images/active_email.png';
import { IMG_ALT } from 'consts/app';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showSuccessModal } from 'components/Modals/CommonModals';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { onChangeAuthPage } from 'features/home/homeSlice';
import authApi from 'api/auth';
import { useHandleResponseError } from 'hooks/useHandleResponseError';

interface VerifyEmailProps {}

const VerifyEmail: React.FunctionComponent<VerifyEmailProps> = () => {
  const [searchParams] = useSearchParams();
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleResponseError = useHandleResponseError();
  const token = useMemo((): string | null => {
    return searchParams.get('token');
  }, [searchParams]);

  const handleClick = async () => {
    const { ok, error } = await authApi.activeAccount(token ? token : '');

    if (ok) {
      const onOk = () => {
        navigate('/', { replace: true });
        dispatch(onChangeAuthPage(0));
      };
      showSuccessModal({
        title: t('active-email.success-title'),
        content: t('active-email.success-msg'),
        onOk,
      });
    }
    if (error) {
      const onOk = () => {
        navigate('/', { replace: true });
        dispatch(onChangeAuthPage(1));
      };
      handleResponseError(error, onOk);
    }
  };

  return (
    <div className="overlay center-content-col primary-text-color show verify-email">
      <div className="auth-form">
        <div className="auth-form__header verify-email__header">
          <h2>Activate your account</h2>
        </div>
        <div className="verify-email__content">
          <img src={active_email} alt={IMG_ALT} className="cursor-pointer" />
          <span>
            Thank you for registering with us. To activate your account, please click the button
            below.
          </span>
          <button className="verify-email__btn" onClick={handleClick}>
            Activate account
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
